// combatpro/views/ViewRoot.js
//
// Stage 33: the #vi-view-root gate block, moved verbatim out of
// CombatProEngineApp.js. ViewRoot owns the 18 activeView gates that previously
// lived inline in the engine. Each gate renders the same component/markup, in
// the same source order, with the same activeView equality checks.
//
// ViewRoot receives ONLY activeView as a prop (per stage brief). The individual
// view components self-serve state via useContext(CombatContext); ViewRoot does
// not read or pass state. MonsterPanel and SpellPanel remain panel components
// and are gated here exactly as before (no MonstersView / SpellsView files).
//
// The wrapping <div id="vi-view-root"> stays in CombatProEngineApp.js; this
// component renders only its children (the gate block), so the DOM is
// byte-identical to the pre-stage output.
//
// No new logic, no new handlers, no route changes, no styling changes, no
// behaviour changes. No optional chaining, no em dash.

import React from 'react';
import MonsterPanel from '../panels/MonsterPanel';
import SpellPanel from '../panels/SpellPanel';
import EncounterDashboardView from './EncounterDashboardView';
import RandomEncountersView from './RandomEncountersView';
import WaveEncountersView from './WaveEncountersView';
import MonsterStudioView from './MonsterStudioView';
import TreasureView from '../treasure/TreasureView';
import EncounterBriefView from './EncounterBriefView';
import PlayerView from './PlayerView';
import EncounterView from './EncounterView';
import PlayersView from './PlayersView';
import SelectionView from './SelectionView';
import MoraleView from './MoraleView';
import AbilitiesView from './AbilitiesView';
import WeaponsView from './WeaponsView';
import LegendaryView from './LegendaryView';
import LairView from './LairView';
import NotesView from './NotesView';
import DiceView from './DiceView';
import AbilityScoresView from './AbilityScoresView';
import ResistanceView from './ResistanceView';
import LastActionsView from './LastActionsView';
import EffectsView from './EffectsView';

function ViewRoot({ activeView, onAddSpell, onOpenSpellEditor }) {
  return (
    <>
      {activeView === 'view-encounter-dashboard' && <EncounterDashboardView />}

      {activeView === 'view-random-encounters' && <RandomEncountersView />}

      {activeView === 'view-wave-encounters' && <WaveEncountersView />}

      {activeView === 'view-monster-studio' && <MonsterStudioView />}

      {activeView === 'view-treasure' && <TreasureView />}

      {activeView === 'view-encounter-brief' && <EncounterBriefView />}

      {activeView === 'view-player-view' && <PlayerView />}

      {activeView === 'view-encounter' && <EncounterView />}

      {activeView === 'view-monsters' && <MonsterPanel />}

      {activeView === 'view-players' && <PlayersView />}

      {activeView === 'view-selection' && <SelectionView />}

      {activeView === 'view-morale' && <MoraleView />}

      {activeView === 'view-abilities' && <AbilitiesView />}

      {activeView === 'view-weapons' && <WeaponsView />}

      {activeView === 'view-legendary' && <LegendaryView />}

      {activeView === 'view-lair' && <LairView />}

      {activeView === 'view-notes' && <NotesView />}

      {activeView === 'view-spells' && <SpellPanel onAddSpell={onAddSpell} onOpenSpellEditor={onOpenSpellEditor} />}

      {activeView === 'view-dice' && <DiceView />}

      {activeView === 'view-ability-scores' && <AbilityScoresView />}

      {activeView === 'view-resistance' && <ResistanceView />}

      {activeView === 'view-last-actions' && <LastActionsView />}

      {activeView === 'view-effects' && <EffectsView />}
    </>
  );
}

export default ViewRoot;
